module.exports = __webpack_public_path__ + "img/noImg.8b37308a.png";